let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5IL0k")).then(() => parcelRequire('8hCRa'));